import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import System from "../../../../helper/system";
import useBomRematchHook from "./BomRematchHook";
import BOM from "@system/config/bom";
import NumericInput from 'react-numeric-input';
import { useAxiosIndicatorCheck } from "../../../../store/hook/useAxiosIndicatorCheck";
import { isObject } from "underscore";
import { useBOMStore } from "../../../../hooks/bom";
import BOMRepository from 'src/repository/BOMRepository';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const bomId = System.getParams().bomId;

const BomRematchData = () => {
    const [__check] = useAxiosIndicatorCheck();
    const [{ row_selected_number, bom_data_list_main_copy }, { }, { set_saved_columns_preference_by_bom_id, SET_bomDataList_based_on_ROW_selected, set_is_rematch_flag }] = useBOMStore();
    const [{  }, {system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    let ColumnsForFinish = useSelector((state) => state.entities.system.stateToRedux['setColumnsForFinish']);
    const [getDisplayStatusForFinishColumns] = useBomRematchHook();
    const { storageName } = System

    useEffect(() => {
        // Check LocalStorage Variables & Remove 
        if (localStorage.getItem(storageName.FLASH_MESSAGE_REMATCH)) {
            system_alert_indicator({
                name: 'FLASH_MESSAGE_REMATCH',
                message: localStorage.getItem(storageName.FLASH_MESSAGE_REMATCH),
                type: BOMRepository.getBOMAlertClass(localStorage.getItem(storageName.FLASH_MESSAGE_REMATCH))
            })
            localStorage.removeItem(storageName.FLASH_MESSAGE_REMATCH);
        }
    }, [])
    const finishColumns = async () => {
        let columnMappingList = [];
        if (Object.entries(ColumnsForFinish).length > 0) {
            Object.entries(ColumnsForFinish).map((v) => {
                columnMappingList.push({
                    bomColumnName: v[1].bomColumnName,
                    columnName: v[1].columnName,
                });
            });
            await set_saved_columns_preference_by_bom_id({ bomId, row_selected_number, columnMappingList });
            await set_is_rematch_flag({ bomId: bomId })
            window.location.href = BOM.getBomDetailByIdRouteURL(bomId)
        }
    };
    const d = getDisplayStatusForFinishColumns();
    return (
        <>
            <div className="row bs5">
                <div className="col-sm-12">
                    <h4>Define Column Headers</h4>
                    <p>Define the column headers to match your data.<b className={'px-1'}>Manufacture Part Number OR Customer Part Number </b>is required.</p>
                </div>
                <div className="col-12">
                    {!d.validation_flags.mpn_cpn_available &&
                        <div className="bs5 alert alert-warning">
                            Please define the column for <b className={'px-1'}> Manufacture Part Number OR Customer Part Number </b> to continue.
                        </div>
                    }
                    {!d.validation_flags.unique_column_selected &&
                        <div className="bs5 alert alert-warning">
                            Column should be selected Unique.
                        </div>
                    }
                </div>

                <>

                    <div className="col-12 mb-2"
                        style={__check(['BOM_REMATCH_API_CALL', 'BOM_REMATCH_SAVED_API_CALL', 'BOM_REMATCH_OPERATION_API_CALL']).status ? { display: 'none' } : {}}>
                        <b>Select the row that your parts data begins.</b>
                    </div>
                    <div className="col-12 mb-3"
                        style={__check(['BOM_REMATCH_API_CALL', 'BOM_REMATCH_SAVED_API_CALL']).status ? { display: 'none' } : {}}>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="d-flex align-items-center">
                                    <span className="pe-3 text-nowrap">Data starts on row</span>
                                    <div className="numberbox">
                                        <NumericInput className="form-control form-control-sm w60 py-0"
                                            value={row_selected_number}
                                            min={1}
                                            max={(bom_data_list_main_copy && isObject(bom_data_list_main_copy)) ? Object.entries(bom_data_list_main_copy).length : 1}
                                            onChange={(value) => {
                                                if (!value) {
                                                    value = 0;
                                                }
                                                if (value < 1) {
                                                    value = 1;
                                                }
                                                let m = (bom_data_list_main_copy && isObject(bom_data_list_main_copy)) ? Object.entries(bom_data_list_main_copy).length : 1;
                                                if (value >= m) {
                                                    value = m;
                                                }
                                                SET_bomDataList_based_on_ROW_selected(value)
                                            }} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 text-right">
                                <button
                                    className={__check(['BOM_REMATCH_OPERATION_API_CALL']).status ? "ms-auto bs5 btn btn-primary d-none" : "ms-auto bs5 btn btn-primary"}
                                    onClick={async () => {
                                        if (d.displayStatus) {
                                            await finishColumns()
                                        }
                                    }}
                                    disabled={!d.displayStatus}
                                >finished Column Matching
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            </div>
        </>
    );
}

export default BomRematchData;